import { Layout } from "./ui/layouts/Layout/Layout.client"
import { MediaFutureDisplayBlock } from "./ui/molecules/ContentBlocks/ContentBlocks.client"

!(async () => {
  Layout()
  MediaFutureDisplayBlock()
})()